import { render, staticRenderFns } from "./CompositeList.vue?vue&type=template&id=6226dbf0&scoped=true&"
import script from "./CompositeList.vue?vue&type=script&lang=js&"
export * from "./CompositeList.vue?vue&type=script&lang=js&"
import style0 from "./CompositeList.vue?vue&type=style&index=0&id=6226dbf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6226dbf0",
  null
  
)

export default component.exports